<template>
  <div class="generate-dialog">
    <Card class="dialog-content">
      <div class="dialog-spinner">
        <Spin size="large" fix></Spin>
      </div>
      <div class="dialog-msg">{{ msg }}</div>
    </Card>
    <div class="reports-container">
      <Report id="report" />
    </div>
  </div>
</template>

<script>
import Report from './Report';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    Report
  },
  computed: {
    ...mapGetters('dataStore', ['selectedASN', 'month']),
    date() {
      let start, end;

      if (process.env.VUE_APP_REPORT_MODE) {
        end = dayjs.utc().subtract(1, 'day');
        if (this.month === 'this') {
          start = dayjs.utc().subtract(30, 'day');
        } else if (this.month === 'last') {
          start = dayjs.utc().subtract(60, 'day');
        } else {
          return 'N/A';
        }
      } else {
        end = dayjs.utc();
        if (this.month === 'this') {
          start = dayjs.utc().subtract(29, 'day');
        } else if (this.month === 'last') {
          start = dayjs.utc().subtract(59, 'day');
        } else {
          return 'N/A';
        }
      }

      return `${start.format('DD-MM-YYYY')}/${end.format('DD-MM-YYYY')}`;
    },
    reportTitle() {
      return `DASH Report for ${this.date}`;
    }
  },
  data() {
    return {
      msg: ''
    };
  },
  mounted() {
    this.msg = 'We are creating your report...';
    // set the timeout as 2s, which is 1s before, because the charts need a while for rendering and showing correctly after the animation
    setTimeout(() => this.download(), 2000);
  },
  methods: {
    download() {
      this.msg = 'Saving as PDF format...';
      const element = this.$el.getElementsByClassName('report')[0];
      domtoimage.toPng(element).then(blob => {
        const doc = new jsPDF({
          orientation: 'p',
          unit: 'px',
          format: 'a4',
          compress: true
        });
        const margin = 2;
        const width = doc.internal.pageSize.getWidth() - margin;
        const height = doc.internal.pageSize.getHeight() - margin;
        doc.addImage(blob, 'png', margin, margin, width, height);
        this.msg = 'Done!';
        doc.save(`${this.reportTitle}.pdf`);
        setTimeout(() => this.$store.dispatch('endDownloadPDF'), 1000);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.generate-dialog {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;

  .dialog-content {
    width: 300px;
    padding: 10px;
    background: white;

    .dialog-spinner {
      height: 100px;
      position: relative;
    }

    .dialog-msg {
      text-align: center;
    }
  }
}

.reports-container {
  position: fixed;
  background: white;
  // z-index: 99999999999999;
  // left: 400px;
  // top: -600px;
  left: 100vw;
}
</style>
